














































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import sharedReportsApi, {SharedReportsApi} from '../shared-reports/api';
import moment from 'moment';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import _ from 'lodash';
import config from '@/config';
import { mixins } from 'vue-class-component';

@Component({})
export default class SharedReports extends mixins<ReportMetricsMixin>(ReportMetricsMixin) {
  sharedReportsApi: SharedReportsApi = sharedReportsApi;

  @Prop() isTabActive: any;

  search: string = ''
  rows: any = [];
  rowsOnPage: number = 10;
  copiedLinkId: string = '';
  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };

  sortItems(items, key, type?) {
    return _.orderBy(items, item => {
      if (key === 'created') {
        return moment(item.created).format('YYYYMMDD HH:mm:ss')
      }
      return item[key]
    }, [type ? 'asc' : 'desc']);
  }

  isDateExpired(from, to = moment()) {
    return this.dateLocal(to).isAfter(this.dateLocal(from))
  }

  dateLocal(date) {
    return moment(moment.utc(date).toDate()).local()
  }

  get infoText() {
    return this.t('The <b>Shared Reports</b> feature enables clients to create reports for third parties without granting access to their BeMob account.<br>Reports can be generated for all general and detailed data, excluding <b>Postbacks, Conversions, Live Visits, Live Clicks and Errors</b>.<br>To share a report, navigate to the desired reporting tab and click the {0}.<br>The generated link can be shared immediately.<br>Owners and Admins can create up to 100 shared reports, and all shared report links will be stored in the section for easy access.',
        [`<i class="v-icon icon-share fas fa-share-square"></i>`])
  }

  get tableRows() {
    if (!this.rows) return [];
    return this.rows.map((row: any) => ({
      created: row.created,
      name: row.name,
      link: `${config.sharedReportsURL}/${row.id}`,
      id: row.id,
      actions: '',
      status: row.status,
      showDate: row.showDate,
      queryConditions: row.queryConditions,
      availableUntil: row.availableUntil,
      updated: row.updated,
      updatedBy: row.updatedBy,
      searchBy: row.searchBy,
      timezone: row.timezone,
    }))
  }

  get filteredRows() {
    return this.sortItems(this.tableRows.filter(({ name }) => name.toLowerCase().startsWith(this.search.toLowerCase())),'created')
  }

  get headers() {
    return [
      {
        text: this.t('Creation Date'),
        value: 'created',
        sortable: true
      },
      {
        text: this.t('Name'),
        value: 'name',
        sortable: true
      },
      {
        text: this.t('Link'),
        value: 'link',
        sortable: false
      },
      {
        text: this.t('Available Until'),
        value: 'availableUntil',
        sortable: false
      },
      {
        value: 'actions',
        sortable: false
      },
    ]
  }

  confirmChangeStatus(data) {
    if (this.isDateExpired(data.availableUntil)) {
      this.sharedReportsApi.getSharedReports()
    }

    const modalChangeStatusLabel = data.status === 'inactive' ?
      this.t('The access to report for the third party will be restored.') :
      this.t('The access to report for the third party will be blocked.')

    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: modalChangeStatusLabel,
      onConfirm: () => {
        const { id, ...restParams } = data
        const status = restParams.status === 'inactive' ? 'active' : 'inactive'
        this.sharedReportsApi.update(id, { ...restParams, status })
      },
    }})
  }

  editReport(data) {
    this.bus.emit('open-dialog', 
      {
        name: 'ShareReportDialog',
        data: {
          action:'edit',
          formData:data
        }
      }
    );
  }

  duplicateReport(data) {
    this.bus.emit('open-dialog', 
      {
        name: 'ShareReportDialog',
        data: {
          action:'duplicate',
          formData:data
        }
      }
    );
  }

  confirmDeleteReport(id: string) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('Deleted report can not be restored.'),
      onConfirm: () => this.sharedReportsApi.delete(id),
    }})
  }

  copyLink(id:string){
    const input = this.$refs[id] as HTMLInputElement;
    input.select() ;
    document.execCommand('copy');
    this.copiedLinkId=id
    setTimeout(() => (this.copiedLinkId = null), 1500);
  }

  @Watch('isTabActive')
  propsChanged() {
    // hide tooltip if tab change
    this.copiedLinkId=null;
  }

  @Watch('sharedReportsApi.data')
  domainsDataReceived() {
    this.rows = this.sharedReportsApi.data;
  }

  loadSharedReports() {
    this.sharedReportsApi.getSharedReports()
  }

  mounted(){
    this.bus.on('load-shared-reports', this.loadSharedReports);
  }

  beforeDestroy() {
    this.bus.off('load-shared-reports', this.loadSharedReports);
  }
}
